import React from 'react'
import LimitCard from './LimitCard'

// 16 to 90, the range the API has always been offered.
const MAX_OPTIONS = Array.from({ length: 75 }, (_, index) => index + 16)

const SetMaxPlayerValue = (props) => (
  <LimitCard
    field="max_limit"
    limitType="max"
    title="Maximum Value"
    note="Add pricier values above the default range."
    current={props.advanceMaxPlayerprice}
    edge={props.defaultHigh}
    options={MAX_OPTIONS}
    symbol={props.symbol}
    requiredMessage="Max Limit is required"
    fetchData={props.fetchData}
  />
)

export default SetMaxPlayerValue
